
import { useState, useCallback } from 'react';
import { ChatGroup } from '@/types/chat';

interface User {
  id: string;
  username: string;
  userType: 'supabase' | 'internal';
}

interface UseChatGroupSelectionProps {
  onSelectGroup: (group: ChatGroup) => void;
}

export const useChatGroupSelection = ({ onSelectGroup }: UseChatGroupSelectionProps) => {
  const [selectedGroup, setSelectedGroup] = useState<ChatGroup | null>(null);

  const selectGroup = useCallback(async (group: ChatGroup) => {
    console.log('=== SELECTING GROUP ===');
    console.log('Group to select:', group.chat_name, 'ID:', group.chat_id);
    
    setSelectedGroup(group);
    onSelectGroup(group);
    
    console.log('✅ Group selection complete');
  }, [onSelectGroup]);

  const clearSelection = useCallback(() => {
    setSelectedGroup(null);
  }, []);

  return {
    selectedGroup,
    selectGroup,
    clearSelection
  };
};
